import { create } from 'zustand';

export interface IConfirmWinnerState {
  isOpen: boolean;
  isLoading: boolean;
  title: string;
  variantName: string;
  description: string;
  onConfirm?: () => void;
}

export interface IConfirmWinnerActions {
  setModalLoading: (isLoading: boolean) => void;
  openModal: (params: {
    title: string;
    variantName: string;
    description: string;
    onConfirm?: () => void;
  }) => void;
  closeModal: () => void;
}

export type IConfirmWinnerStore = IConfirmWinnerState & IConfirmWinnerActions;

const INITIAL_CONFIRM_MODAL_STATE: IConfirmWinnerState = {
  isOpen: false,
  isLoading: false,
  title: '',
  variantName: '',
  description: '',
};

export const useConfirmWinnerStore = create<IConfirmWinnerStore>((set) => ({
  ...INITIAL_CONFIRM_MODAL_STATE,
  setModalLoading: (isLoading) => {
    set(() => ({
      isLoading,
    }));
  },
  openModal: ({ title, variantName, description, onConfirm }) => {
    set(() => ({ isOpen: true, title, variantName, description, onConfirm }));
  },
  closeModal: () => {
    set(() => ({ isOpen: false, onConfirm: undefined }));
  },
}));
